if (!customElements.get('nopa-carousel')) {
  class NopaCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.prevBtn && this.prevBtn.addEventListener('click', () => this.page(-1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.page(1));
      this.track.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
      window.addEventListener('resize', () => this.requestUpdate());
      this.initDrag();
      this.requestUpdate();
    }
    requestUpdate() {
      cancelAnimationFrame(this._raf);
      this._raf = requestAnimationFrame(() => this.updateArrows());
    }
    slideStep() {
      const slide = this.track.querySelector(':scope > *');
      if (!slide) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || 0) || 0;
      return slide.getBoundingClientRect().width + gap;
    }
    page(dir) {
      const perView = Math.max(1, Math.floor(this.track.clientWidth / this.slideStep()));
      this.track.scrollBy({ left: dir * perView * this.slideStep(), behavior: 'smooth' });
    }
    updateArrows() {
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prevBtn) this.prevBtn.toggleAttribute('disabled', this.track.scrollLeft <= 2);
      if (this.nextBtn) this.nextBtn.toggleAttribute('disabled', this.track.scrollLeft >= max);
    }
    initDrag() {
      let startX = 0, startScroll = 0, dragging = false, moved = false;
      const t = this.track;
      t.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        dragging = true; moved = false;
        startX = e.clientX; startScroll = t.scrollLeft;
        t.style.scrollSnapType = 'none';
        t.style.scrollBehavior = 'auto';
      });
      window.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 5) moved = true;
        t.scrollLeft = startScroll - dx;
      });
      window.addEventListener('pointerup', () => {
        if (!dragging) return;
        dragging = false;
        t.style.scrollSnapType = '';
        t.style.scrollBehavior = '';
      });
      t.addEventListener('click', (e) => { if (moved) { e.preventDefault(); moved = false; } }, true);
    }
  }
  customElements.define('nopa-carousel', NopaCarousel);
}
